import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { Subject } from 'rxjs';
import { FilterService } from '../../../services/filter.service';
import { FilterUtilService } from '../shared/filter-util.service';
import { takeUntil } from 'rxjs/operators';
import { ListedUnlistedFilter } from './filter-listed-unlisted.model';

@Component({
  selector: 'app-filter-listed-unlisted',
  templateUrl: './filter-listed-unlisted.component.html',
  styleUrls: ['./filter-listed-unlisted.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  encapsulation: ViewEncapsulation.None,
})
export class FilterListedUnlistedComponent implements OnInit, OnDestroy {
  @Input() filter: any;
  @Input() readOnly = false;

  listingStatuses: TreeNode[] = [];
  formDirty = false;
  searchStrategyId: number;
  showLoader = false;

  private destroy$ = new Subject();

  constructor(private filterService: FilterService, private filterUtil: FilterUtilService) {}

  ngOnInit(): void {
    this.loadInitialData();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  loadInitialData() {
    this.filterUtil.spinnerRS.next(true);

    this.filterService
      .getListingStatuses$(this.readOnly)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_listingStatuses) => {
        this.listingStatuses = _listingStatuses;
        this.initializeForm();
        this.filterUtil.spinnerRS.next(false);
      });
  }

  initializeForm() {
    // if (this.filter != null) {
    // }
    this.filter.listingStatusesSelection = this.listingStatuses.filter((selection) =>
      this.filterUtil.findNodeRecursive(selection.data, (<ListedUnlistedFilter>this.filter).listingStatusesSelection)
    );
  }

  sortSelection(selection: TreeNode[]): void {
    return this.filterUtil.sortSelection(selection);
  }
}
